module.exports = __webpack_public_path__ + "img/Coconut_Prince.418a6b40.jpg";